import classNames from 'classnames';
import { Item } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.css';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  deleteDocument,
} from '../../../redux/reducers/documentsStatusSlice';
import { deleteDocuments } from '../../../db/documentDBAction';
import { selectRows, setDocumentRowAsExpanded } from '../../../redux/reducers/documentsDataSlice';
import { rowCollapseUpdate, rowExpandUpdate, selectSelectedDocumentExpandedId, selectSelectedDocumentId, setDeSelectDocument, setDocumentDeleted, setDocumentExpanded } from '../../../redux/reducers/dashboardSlice';
import { selectInboxId } from '../../../redux/reducers/metadataSlice';
import { updateParentsWithChildren } from '../../../redux/reducers/documentsSlice';

function RowContextMenu(props: any) {
  const dispatch = useAppDispatch();
  const selectedDocumentId = useAppSelector(selectSelectedDocumentId);
  const inboxId = useAppSelector(selectInboxId);
  const inboxDocuments = useAppSelector(selectRows)[inboxId];
  const expandedDocumentId = useAppSelector(selectSelectedDocumentExpandedId);
  
  const handleDeleteDocument = () => {
    const loiDoc = props.propsFromTrigger.data;
    const isParentBeingDeleted = loiDoc?.parent === '';
    const parentId = isParentBeingDeleted ? loiDoc.id : loiDoc.parent;
    const checkIfOnlyOneChild = inboxDocuments
      .filter(e => e.parent === parentId).length === 1;
    deleteDocuments([loiDoc.id]).then(() => {
      if (checkIfOnlyOneChild) {
        dispatch(updateParentsWithChildren(parentId));
        dispatch(setDocumentExpanded(''));
      }
      dispatch(deleteDocument(loiDoc.id)).then(() => {
        if (selectedDocumentId === loiDoc.id) {
          dispatch(setDeSelectDocument);
        }
        dispatch(setDocumentDeleted(true));
      });
    });
  };

  return (
    <section>
      <Item
        key='rowContextMenu'
        id='rowContextMenu'
        className={classNames('context-menu-item')}
        onClick={handleDeleteDocument}>
        <span className={classNames('menu-status-text', 'context-menu-text')}>Delete LOI</span>
      </Item>
    </section>
  );
}
export default RowContextMenu;